<mat-dialog-content>
	<p>
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button class="btn btn-primary mr-3" color="primary" (click)="onConfirmClick()"
		tabindex="1">{{confirmButtonText}}</button>
	<button mat-raised-button class="btn btn-primary" mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>